import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CiplaLogo from '../assets/images/cipla.png';
import ViatrisLogo from '../assets/images/viatris.png';
import AbbottLogo from '../assets/images/abbott.png';
import SanofiLogo from '../assets/images/sanofi.png';
import DrlLogo from '../assets/images/drl.png';
import ZydusLogo from '../assets/images/zydus.png';

function Brands() {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    variableWidth: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4.5, slidesToScroll: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2.5, slidesToScroll: 2 } },
    ],
  };
  return (
    <div className='brandsContainer'>
      <Slider {...settings}>
        <div className='brandsLogo'>
          <img src={CiplaLogo} alt='' />
        </div>
        <div className='brandsLogo'>
          <img src={ViatrisLogo} alt='' />
        </div>
        <div className='brandsLogo'>
          <img src={AbbottLogo} alt='' />
        </div>
        <div className='brandsLogo'>
          <img src={SanofiLogo} alt='' />
        </div>
        <div className='brandsLogo'>
          <img src={DrlLogo} alt='' />
        </div>
        <div className='brandsLogo'>
          <img src={ZydusLogo} alt='' />
        </div>
      </Slider>
    </div>
  );
}

export default Brands;
